import React from 'react';

import { Divider, Text } from '@thefarmersfront/kitchen';

import {
  ProductRegisterModalInfoSectionDefault,
  ProductRegisterModalInfoSectionMeasurement,
  ProductRegisterModalInfoSectionPolicy,
} from '.';

import styles from './ProductRegisterModalProductInfoSection.module.scss';

const ProductRegisterModalProductInfoSection = () => {
  return (
    <div className={styles['product-info-section']}>
      <Text className={styles['section-title']} size="xxlarge" weight="bold">
        상품 정보
      </Text>

      <ProductRegisterModalInfoSectionDefault />

      <div className={styles['divider-wrapper']}>
        <Divider color="gray100" />
      </div>

      <ProductRegisterModalInfoSectionPolicy />

      <div className={styles['divider-wrapper']}>
        <Divider color="gray100" />
      </div>

      <ProductRegisterModalInfoSectionMeasurement />
    </div>
  );
};

export default ProductRegisterModalProductInfoSection;
